'use client';

import {
	daysToMs,
	type FetchUserMeAddressData,
	getResponseStatusIfAxiosError,
	sessionAtom,
	type UserAddress
} from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { chiliPayUserApi } from '../api';

// TODO - Can be deprecated and rely on the useMeQuery
export type UseUserAddressQueryOptions = Omit<
	UseQueryOptions<FetchUserMeAddressData, unknown, undefined | UserAddress>,
	'queryFn' | 'select'
>;
export const UseUserAddressQueryKey = ['user-address'];
export const useUserAddressQuery = (options?: UseUserAddressQueryOptions) => {
	const sessionTokens = useAtomValue(sessionAtom);

	return useQuery<FetchUserMeAddressData, unknown, undefined | UserAddress>({
		enabled: !!sessionTokens?.authToken,
		queryFn: async () =>
			(await chiliPayUserApi).fetchUserMeAddress({
				customErrorInterceptor: e => getResponseStatusIfAxiosError(e) === 404
			}),
		queryKey: UseUserAddressQueryKey,
		select: res => res.data,
		staleTime: daysToMs(1),
		...options
	});
};
